export default __webpack_public_path__ + "static/media/1768.8157c0b0.png";